import React, { useEffect } from "react";
import { Button, Card, Col, Form, Input, message, Row, Skeleton, Typography } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { useState } from "react";
import "react-chat-elements/dist/main.css";
import {
  MeetingLink,
  MessageList,
  Input as MessageBoxInput,
  Button as MessageBoxButton,
} from "react-chat-elements";
import Post from "../services/Post";
import Get from "../services/Get";
import {
  CheckCircleTwoTone,
  CloseOutlined,
  QuestionCircleTwoTone,
} from "@ant-design/icons";

const Support = () => {
  const [formData, setFormData] = useState({ title: "", message: "" });
  const [tickets, setTickets] = useState([]);
  const [selectedChat, setSelectedChat] = useState();
  const [chatMessage, setChatMessage] = useState("");
  const [loadingTickets, setLoadingTickets] = useState(true);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const submitForm = async () => {
    console.log(formData);
    const res = await Post.AddTicket(formData);
    if (res.error) {
      message.error(res.message);
    }
    message.success(res.message);
    getTickets();
    setFormData({ title: "", message: "" });
  };

  const handleSendMessage = async () => {
    if (!chatMessage || !selectedChat) return;

    const res = await Post.AddTicketReply({
      ticket_id: selectedChat.id,
      message: chatMessage,
    });

    if (res.error) {
      return message.error(res.message);
    }

    message.success("Reply sent!");
    setChatMessage("");
    viewTicketChat(selectedChat.id);
  };

  const getTickets = async () => {
    setLoadingTickets(true);
    const res = await Get.getTickets();
    setTickets(res.data);
    setLoadingTickets(false);
  };

  const viewTicketChat = async (ticket) => {
    const res = await Get.getTicketChat(ticket);
    console.log("====================================");
    console.log(res);
    console.log("====================================");
    setSelectedChat(res.data);
  };

  useEffect(() => {
    getTickets();
  }, []);

  return (
    <div>
      <Card className="suppot_card">
        <Form>
          <div className="support_form">
            <Typography.Title level={3}>Support Ticket</Typography.Title>
            <Input
              type="text"
              placeholder="Subject"
              name="title"
              value={formData.title}
              onChange={handleChange}
            ></Input>
            <TextArea
              type="text"
              rows={6}
              placeholder="Enter Message"
              name="message"
              value={formData.message}
              onChange={handleChange}
            ></TextArea>
            <Button onClick={submitForm} className="form-btn">
              Submit
            </Button>
          </div>
        </Form>

        <div className="recent_tkt">
          <h4> Recent Tickets </h4>
          {loadingTickets ? (
            <ul>
              {[1, 2, 3].map((i) => (
                <li key={i} style={{ marginBottom: 16 }}>
                  <Skeleton active title={false} paragraph={{ rows: 2 }} />
                </li>
              ))}
            </ul>
          ) : (
            <ul>
              {tickets.map((ticket) => (
                <li key={ticket.id}>
                  <div>
                    {ticket.title} <br />
                    <span>
                      {ticket.status === "open" ? (
                        <>
                          <QuestionCircleTwoTone twoToneColor={"red"} /> Open
                        </>
                      ) : (
                        <>
                          <CheckCircleTwoTone twoToneColor="#52c41a" /> Closed
                        </>
                      )}
                    </span>
                  </div>
                  <span>
                    <Button
                      className="form-btn"
                      onClick={() => viewTicketChat(ticket.id)}
                    >
                      View Details
                    </Button>
                  </span>
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* {submittedData && ({ submittedData.name } {submittedData.message} )} */}
      </Card>
      {selectedChat && (
        <Card className="chat_box">
          {/* <Typography.Title level={4}>
            Ticket Chat: {selectedChat.title}
          </Typography.Title> */}
          <Row
            justify="space-between"
            align="middle"
            style={{ marginBottom: "1rem" }}
          >
            <Typography.Title level={4} style={{ margin: 0 }}>
              Ticket Chat: {selectedChat.title}
            </Typography.Title>
            <CloseOutlined
              onClick={() => setSelectedChat(null)}
              style={{
                fontSize: "18px",
                cursor: "pointer",
                color: "#ff4d4f",
              }}
            />
          </Row>

          <MessageList
            className="message-list"
            lockable={true}
            toBottomHeight={"100%"}
            dataSource={[
              {
                position: "right",
                type: "text",
                title: selectedChat.user?.name || "You",
                text: selectedChat.message,
                date: new Date(selectedChat.created_at),
              },
              ...selectedChat.replies.map((reply) => ({
                position: reply.user_id === 1 ? "left" : "right", // Assuming 1 = Admin
                type: "text",
                title: reply.user.name,
                text: reply.message,
                date: new Date(reply.created_at),
              })),
            ]}
          />
          <Row justify={"space-between"}>
            <Col span={20}>
              <Input.TextArea
                rows={2}
                placeholder="Type here..."
                value={chatMessage}
                onChange={(e) => setChatMessage(e.target.value)}
              />
            </Col>
            <Col>
              <Button
                type="primary"
                className="form-btn"
                onClick={handleSendMessage}
              >
                Send
              </Button>
            </Col>
          </Row>
        </Card>
      )}
    </div>
  );
};

export default Support;
